module.exports = __webpack_public_path__ + "img/xinnian.6098e074.png";